import { APIPostRequest } from '@ancon/wildcat-types'

import Request from '../../client/Request'
import { APIType } from '../../types'
import endpoints from '../endpoints'
import {
  GuestWaitlistJoinRequest,
  GuestWaitlistResponse,
} from '../../../features/booking/types'

type WaitlistEntriesAPI = {
  post: {
    join: APIPostRequest<
      GuestWaitlistResponse,
      GuestWaitlistJoinRequest,
      { tenantId: string; outletId: string }
    >
  }
}

const waitlistEntries: WaitlistEntriesAPI = {
  post: {
    join: new Request(
      endpoints.reservation.tenants.byId.outlets.byId.waitlistEntries.list,
      {
        apiType: APIType.Reservation,
      },
    ).post,
  },
}

export default waitlistEntries
